import { render, staticRenderFns } from "./qa_box.vue?vue&type=template&id=5db7c4ca&scoped=true&"
import script from "./qa_box.vue?vue&type=script&lang=js&"
export * from "./qa_box.vue?vue&type=script&lang=js&"
import style0 from "./qa_box.vue?vue&type=style&index=0&id=5db7c4ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db7c4ca",
  null
  
)

export default component.exports